import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function TermsOfUse() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div data-testid="terms-of-use-page" className="min-h-screen bg-white">
      <div className="max-w-3xl mx-auto px-6 md:px-8 py-20 md:py-28">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-indigo-600 hover:text-indigo-500 mb-8 transition-colors" data-testid="back-to-home">
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>

        <h1 className="font-heading text-3xl sm:text-4xl font-bold text-slate-900 mb-4">Terms of Use</h1>
        <p className="text-sm text-slate-400 mb-12">Last updated: February 2026</p>

        <div className="prose prose-slate max-w-none space-y-8 text-sm leading-relaxed text-slate-600">
          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">1. Acceptance of Terms</h2>
            <p>By accessing or using the SkillsimAI website and platform, you agree to be bound by these Terms of Use and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this site.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">2. Use of Service</h2>
            <p>SkillsimAI provides an AI-powered soft skills training simulator. You may use our services for personal and professional development purposes. You agree not to:</p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>Use the service for any unlawful purpose</li>
              <li>Attempt to reverse engineer, decompile, or disassemble the AI technology</li>
              <li>Interfere with or disrupt the service or servers</li>
              <li>Share your account credentials with unauthorized parties</li>
              <li>Use the platform to generate harmful, abusive, or inappropriate content</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">3. Intellectual Property</h2>
            <p>All content, features, and functionality of the SkillsimAI platform — including but not limited to text, graphics, logos, icons, images, audio clips, data compilations, and software — are the exclusive property of SkillsimAI and are protected by international copyright, trademark, and other intellectual property laws.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">4. AI-Generated Content</h2>
            <p>The conversations and feedback generated by our AI are for training purposes only and should not be considered professional advice. SkillsimAI is not responsible for any decisions made based on AI-generated content.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">5. Limitation of Liability</h2>
            <p>SkillsimAI shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use or inability to use the service. Our total liability shall not exceed the amount paid by you in the twelve months preceding the claim.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">6. Governing Law</h2>
            <p>These Terms shall be governed by and construed in accordance with the laws of England and Wales, without regard to its conflict of law provisions.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">7. Contact</h2>
            <p>For questions about these Terms, contact us at:</p>
            <p className="mt-2">
              SkillsimAI<br />
              1 Canada Square, Canary Wharf<br />
              London E14 5AB, UK<br />
              Email: info@skillsimai.com<br />
              Phone: +44 20 3059 3450
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
